import * as React from 'react';

import {
  IGridElement,
  ILinkCreateBulkProps,
  ILinkCreateBulkState,
  IRowValidation,
  ISheetHeaders,
} from './types';
import API from 'src/services/api';
import Sheet from './components/Sheet';
import { Button, Icons } from 'src/components';
import { countMessages } from './components/services/validationMessages';

class LinkCreateBulk extends React.Component<
  ILinkCreateBulkProps,
  ILinkCreateBulkState
> {
  state: ILinkCreateBulkState = {
    loadingData: true,
    parameterData: [],
    notValidatedWarning: false,
    validationCounts: undefined,
  };

  componentDidMount() {
    this.fetchParameterData();
  }

  fetchParameterData = async () => {
    const { marketId, templateId } = this.props.match.params;
    const { getData } = API.LINK_UPLOAD.getParameterItems(marketId, templateId);
    const data = await getData();
    const parameterData = data.linkCreationRequestParameters;
    this.setState({
      loadingData: false,
      parameterData,
    });
  };

  upload = (grid: IGridElement[][], headers: ISheetHeaders) => async () => {
    const { marketId, templateId } = this.props.match.params;
    const links = grid.map((row) =>
      Object.fromEntries(
        row.map((cell, index) => {
          const parameterName = this.state.parameterData[index].name;
          let value = cell.value;
          if (cell.type === 'select' || cell.readOnly) {
            const parameter = headers[index].options.find(
              (o) => String(o.value.id) === value
            );
            if (parameter) {
              value = parameter.label;
            }
          }
          return [parameterName, value];
        })
      )
    );
    const { getData } = API.LINK_UPLOAD.createBulkUpload({
      profile: {
        id: marketId,
      },
      customTemplateId: templateId === '-1' ? null : templateId,
      emailCc: null,
      links,
    });
    const data = await getData();
    const location = {
      pathname: '/link-bulk-upload',
      state: { newBulkId: data.id },
    };
    this.props.history.push(location);
  };

  startUpload =
    (
      grid: IGridElement[][],
      validation: IRowValidation[],
      headers: ISheetHeaders
    ) =>
    () => {
      const validationCounts = countMessages(validation);
      const allValid = validationCounts.ok === validation.length;
      if (!allValid) {
        this.setState({
          notValidatedWarning: true,
          validationCounts,
        });
        return;
      }
      this.upload(grid, headers)();
    };

  resetWarning = () => {
    this.setState({
      notValidatedWarning: false,
    });
  };

  render() {
    if (this.state.loadingData) {
      return <div className="loader opacity-25 h-64" />;
    }
    const { location } = this.props;
    return (
      <Sheet
        initialLinks={location.state && location.state.links}
        parameterData={this.state.parameterData}
        onChange={this.resetWarning}
      >
        {(grid, validation, headers) => (
          <div className="flex flex-col items-center">
            {this.state.notValidatedWarning && this.state.validationCounts ? (
              <div className="bg-grey-lighter p-6 fade-in">
                <div className="flex mb-6">
                  <Icons.Warning className="mr-4 text-lg" />
                  <div className="mt-1">
                    <p className="mb-2">The links contain issues:</p>
                    <ul className="pl-3">
                      {this.state.validationCounts.errors !== 0 && (
                        <li>
                          links containing errors:{' '}
                          <strong>{this.state.validationCounts.errors}</strong>
                        </li>
                      )}
                      {this.state.validationCounts.duplicates !== 0 && (
                        <li>
                          duplicate links:{' '}
                          <strong>
                            {this.state.validationCounts.duplicates}
                          </strong>
                        </li>
                      )}
                      {this.state.validationCounts.unvalidated !== 0 && (
                        <li>
                          links not validated:{' '}
                          <strong>
                            {this.state.validationCounts.unvalidated}
                          </strong>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <p className="text-lg mb-6">
                  Are you sure you want to proceed?
                </p>

                <div className="flex">
                  <Button
                    onClick={this.resetWarning}
                    className="block mr-2"
                    error={true}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={this.upload(grid, headers)}
                    className="block"
                  >
                    Yes, start the Bulk Upload
                  </Button>
                </div>
              </div>
            ) : (
              <Button
                onClick={this.startUpload(grid, validation, headers)}
                className="block mb-2"
              >
                Start Bulk Upload
              </Button>
            )}
          </div>
        )}
      </Sheet>
    );
  }
}

export default LinkCreateBulk;



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/LinkCreateBulk.tsx